import { render } from "./Cryptocurrencies.vue?vue&type=template&id=3ce1eaef&scoped=true&ts=true"
import script from "./Cryptocurrencies.vue?vue&type=script&lang=ts"
export * from "./Cryptocurrencies.vue?vue&type=script&lang=ts"

import "./Cryptocurrencies.vue?vue&type=style&index=0&id=3ce1eaef&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce1eaef"]])

export default __exports__